module.exports = __webpack_public_path__ + "static/media/13.QC-Lab.dfecdf28.webp";